import {mapGetters, mapActions} from 'vuex';

import * as USER from '@/store/constants/user';

import SearchInput from '@/components/SearchInput';
import ListWithSpinner from '@/components/ListWithSpinner';
import TableListActions from '@/components/TableListActions';
import TableRowActions from "@/components/TableRowActions";

export default {
  inject: ['$validator'],
  data() {
    return {
      name: 'UserList',
      columns: [
        {key: 'name', sortable: true},
        'email',
        {key: 'created_at', sortable: true},
        'updated_at',
        'role',
        'action'
      ],
      wildcard: null,
      isProcessing: false
    }
  },

  components: {
    ListWithSpinner,
    SearchInput,
    TableListActions,
    TableRowActions
  },

  computed: {
    ...mapGetters({
      users: USER.GET_USER_LIST
    }),

    items() {
      return this.users.data;
    }
  },

  methods: {
    ...mapActions({
      listUsers: USER.ACTION_LIST_USER
    }),

    /**
     * View user detail
     *
     * @param item
     */
    viewDetail(item) {
      this.$router.push(
        {
          name: 'UserDetail',
          params: {id: item.id, user: item}
        }
      );
    },

    /**
     * Refresh list data.
     */
    refreshData() {
      this.isProcessing = true;

      let params = {
        page: this.users.current_page,
        order_by: [`name,asc`]
      };

      if (this.wildcard) {
        params = {...params, ...{wildcard: this.wildcard}};
      }

      this.listUsers(params).finally(() => {
        this.isProcessing = false;
      });
    },

    handlePaginate() {
      this.refreshData();
    },

    /**
     * Filter the user list.
     */
    filterUser: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`name,like,${item}`] : null;
      this.refreshData();
    }, 1000)
  },

  created() {
    this.refreshData();
  }
}



// WEBPACK FOOTER //
// ./src/views/User/js/list.js